import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { useToggle } from 'react-use';

import { __t, PAYMENT_PROVIDERS } from '@mssgme/shared';
import { useModalThemes, usePaymentConfigs } from '../../../hooks';
import { ThemedButton, ThemedModal } from '../../../UI';
import StripeCheckoutForm from '../../StripeCheckoutForm';

const propTypes = {
    order: PropTypes.object.isRequired,
    onPay: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

export function StripePayment({ order, disabled, onPay }) {
    const { icon: Icon, label } = PAYMENT_PROVIDERS.stripe;
    const { payments, isSingularOnline } = usePaymentConfigs();
    const { contentStyle } = useModalThemes();
    const [isModal, toggleModal] = useToggle(false);
    const stripePromise = useMemo(() => loadStripe(payments.stripe.publicKey), [payments.stripe.publicKey]);

    const elements = (
        <Elements stripe={stripePromise}>
            <StripeCheckoutForm orderId={order._id} disabled={disabled} onPay={onPay} />
        </Elements>
    );

    if (isSingularOnline) {
        return elements;
    }

    return (
        <ThemedButton
            fullWidth
            beforeIcon={<Icon size={24} />}
            theme={contentStyle}
            disabled={disabled}
            onClick={toggleModal}
            contentAlignLeft
        >
            {__t('payWith', { provider: label })}

            {isModal && (
                <ThemedModal noop compact overlay padding title={label} onClose={toggleModal}>
                    {elements}
                </ThemedModal>
            )}
        </ThemedButton>
    );
}

StripePayment.propTypes = propTypes;
